import { loadScript } from '../components/load_script';

export function map() {
    const loadMap = document.querySelectorAll('.js-loadMap');

    const initMap = (elem) => {
        elem.classList.add('is-init');

        loadScript('//api-maps.yandex.ru/2.1.73/?lang=ru_RU').then(function() {
            // Пример реализации боковой панели на основе наследования от collection.Item.
            // Боковая панель отображает информацию, которую мы ей передали.
            ymaps.modules.define('Panel', [
                'util.augment',
                'collection.Item'
            ], function (provide, augment, item) {
                // Создаем собственный класс.
                var Panel = function (options) {
                    Panel.superclass.constructor.call(this, options);
                };

                // И наследуем его от collection.Item.
                augment(Panel, item, {
                    onAddToMap: function (map) {
                        Panel.superclass.onAddToMap.call(this, map);
                        this.getParent().getChildElement(this).then(this._onGetChildElement, this);
                        // Добавим отступы на карту.
                        // Отступы могут учитываться при установке текущей видимой области карты,
                        // чтобы добиться наилучшего отображения данных на карте.
                        map.margin.addArea({
                            top: 0,
                            left: 0,
                            width: '250px',
                            height: '100%'
                        })
                    },

                    onRemoveFromMap: function (oldMap) {
                        if (this._$control) {
                            this._$control.remove();
                        }
                        Panel.superclass.onRemoveFromMap.call(this, oldMap);
                    },

                    _onGetChildElement: function (parentDomContainer) {
                        parentDomContainer.innerHTML += '<div class="customControl"><div class="content"></div><div class="closeButton"></div></div>';
                        this._$control = document.querySelector('.customControl');
                        this._$content = document.querySelector('.content');

                        document.querySelector('.closeButton').addEventListener('click' , this._onClose);
                    },
                    _onClose: function () {
                        document.querySelector('.customControl').style.display = 'none';
                    },
                    // Метод задания контента панели.
                    setContent: function (text) {
                        // При задании контента будем показывать панель.
                        this._$control.style.display = 'flex';
                        this._$content.innerHTML = text;
                    }
                });

                provide(Panel);
            });

            /**
             * Инициализация Яндекс.Карты
             */
            ymaps.ready(['Panel']).then(function() {
                var MapContainer      = elem;
                var latitude          = MapContainer.getAttribute('data-latitude');
                var longitude         = MapContainer.getAttribute('data-longitude');
                var zoom              = MapContainer.getAttribute('data-zoom');

                var myMap = new ymaps.Map(MapContainer, {
                    center: [latitude, longitude],
                    zoom: zoom,
                    controls: []
                }, {
                    searchControlProvider: 'yandex#search'
                });

                var zoomControl = new ymaps.control.ZoomControl({options: { position: { left: 10, top: 108 }}});
                    myMap.controls.add(zoomControl);
                    myMap.behaviors.disable('scrollZoom');

                var myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
                    balloonContent: ''
                }, {
                    iconLayout: 'default#image',
                    preset: 'islands#redDotIcon',
                    iconImageHref: '/app/src/img/baloon.svg',
                    iconImageSize: [44, 50],
                    iconImageOffset: [-22, -50],
                });

                myMap.geoObjects.add(myPlacemark);
            });
        });
    }

    loadMap.forEach( item => {
        item.addEventListener('click', () => {
            if (item.classList.contains('is-init')) {
                return false;
            }

            let target = item.dataset.target ? document.querySelector(`.${item.dataset.target}`) : item;

            initMap(target);
        })
    })
}

